export default {
      id: "icon-arrow-fold-usage",
      viewBox: "0 0 16 16",
      url: "/" + "assets/sprite.svg#icon-arrow-fold",
      toString: function () {
        return this.url;
      }
    }